import React, { useEffect, useState } from "react";
import API from "../../Service/Baseservice";
import { useNavigate, useLocation } from "react-router-dom";
import "../Category/Category.css";

const CategoryEdit = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const categoryData = location.state?.category;

    const [formData, setFormData] = useState({
        category_id: "",
        language_id: "",
        category: "",
        description: "",
        status: "active",
        active: 1,
    });

    const [popup, setPopup] = useState({ show: false, type: "", message: "" });
    const [isSubmitting, setIsSubmitting] = useState(false);


    useEffect(() => {
        if (categoryData) {
            setFormData((prev) => ({
                ...prev,
                category_id: categoryData.category_id,
                language_id: categoryData.language_id || "",
                category: categoryData.category || "",
                description: categoryData.description || "",
                status: categoryData.status || "active",
                active: categoryData.active ?? 1,
            }));
        }
    }, [categoryData]);


    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        if (!formData.category || !formData.description) {
            setPopup({
                show: true,
                type: "info",
                message: "Please fill all required fields.",
            });
            return;
        }

        setIsSubmitting(true);
        API.post("faqs_category_edit/update", formData)
            .then((res) => {
                const success = res.data?.success;
                const message = res.data?.message || "Category updated successfully!";
                setPopup({
                    show: true,
                    type: success ? "success" : "error",
                    title: success ? "Success" : "Error",
                    message: success
                        ? "updated successfully!"
                        : res.data?.message || "Something went wrong",
                });


                // if (success) {
                //     setTimeout(() => navigate("/category"), 2000);
                // }
            })
            .catch((err) => {
                console.error("Update Category Error:", err);
                setPopup({
                    show: true,
                    type: "error",
                    message: "Failed to update category. Please try again.",
                });
            })
            .finally(() => setIsSubmitting(false));
    };

    return (
        <div className="category-container1">
            {/* Header */}
            <div className="category-header1">
                <h2 className="category-title1">Edit FAQ Category</h2>
                <div className="header-buttons">
                    <button
                        onClick={handleSubmit}
                        className="btn saves-btn"
                        disabled={isSubmitting}
                    >
                        {isSubmitting ? "Update" : "Update"}
                    </button>
                    <button
                        onClick={() => navigate("/category")}
                        className="cancel-btn "
                    >
                        Back
                    </button>
                </div>
            </div>

            {/* Form */}
            <div className="category-form-card">
                <form onSubmit={handleSubmit}>
                    <div className="form-group1">
                        <label>Category Name <span className="required">*</span></label>
                        <input
                            type="text"
                            name="category"
                            placeholder="Enter category name"
                            value={formData.category}
                            onChange={handleChange}
                        />
                    </div>

                    <div className="form-group1">
                        <label>Description <span className="required">*</span></label>
                        <textarea
                            name="description"
                            placeholder="Enter description"
                            value={formData.description}
                            onChange={handleChange}
                            rows="4"
                        />
                    </div>
                </form>
            </div>

            {/* Popup */}
            {popup.show && (
                <div className="popup-overlay">
                    <div className={`popup-box popup-${popup.type}`}>
                        <h3>{popup.title}</h3>
                        <p>{popup.message}</p>
                        <div className="popup-buttons">
                            <button
                                className="btn ok-btn"
                                onClick={() => {
                                    setPopup({ ...popup, show: false });

                                    if (popup.type === "success") {
                                        navigate("/category");
                                    }
                                }}
                            >
                                OK
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default CategoryEdit;
